<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-25 border-0 rounded-0 bg-white">

          <div class="card-body p-25">
            <!-- Filtres -->
            <div class="row mb-4">
              <div class="col-md-3">
                <label class="form-label">Période</label>
                <select class="form-select" v-model="selectedPeriod" @change="applyFilters">
                  <option value="all">Toute la période</option>
                  <option value="today">Aujourd'hui</option>
                  <option value="week">Cette semaine</option>
                  <option value="month">Ce mois</option>
                  <option value="year">Cette année</option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label">Date de début</label>
                <input type="date" class="form-control" v-model="startDate" @change="applyFilters" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Date de fin</label>
                <input type="date" class="form-control" v-model="endDate" @change="applyFilters" />
              </div>
              <!-- <div class="col-md-3">
                <label class="form-label">Rechercher</label>
                <div class="input-group">
                  <input 
                    type="text" 
                    class="form-control" 
                    placeholder="Titre du document..."
                    v-model="searchTerm" 
                    @keyup.enter="applyFilters" />
                  <button class="btn btn-outline-secondary" type="button" @click="applyFilters">
                    <i class="flaticon-search-interface-symbol"></i>
                  </button>
                </div>
              </div> -->
            </div>

            <!-- Statistiques -->
            <div class="row mb-4">
              <div class="col-md-3">
                <div class="card border-0 bg-light">
                  <div class="card-body text-center">
                    <i class="flaticon-eye fs-30 text-primary mb-2"></i>
                    <h5 class="fw-bold mb-1">{{ totalLectures }}</h5>
                    <small class="text-muted">Total lectures</small>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card border-0 bg-light">
                  <div class="card-body text-center">
                    <i class="flaticon-book fs-30 text-success mb-2"></i>
                    <h5 class="fw-bold mb-1">{{ documentsUniques }}</h5>
                    <small class="text-muted">Documents uniques</small>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card border-0 bg-light">
                  <div class="card-body text-center">
                    <i class="flaticon-calendar fs-30 text-warning mb-2"></i>
                    <h5 class="fw-bold mb-1">{{ lecturesAujourdhui }}</h5>
                    <small class="text-muted">Aujourd'hui</small>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card border-0 bg-light">
                  <div class="card-body text-center">
                    <i class="flaticon-time fs-30 text-info mb-2"></i>
                    <h5 class="fw-bold mb-1">{{ lecturesCetteSemaine }}</h5>
                    <small class="text-muted">Cette semaine</small>
                  </div>
                </div>
              </div>
            </div>

            <!-- Table d'historique -->
            <div class="table-responsive">
              <table class="table table-hover">
                <thead class="table-light">
                  <tr>
                    <th>Document</th>
                    <th>Catégorie</th>
                    <th>Date de lecture</th>
                    <th>Heure</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="historique in historiques" :key="historique.id">
                    <td>
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 me-3">
                          <div class="bg-primary rounded-circle p-2" style="width: 40px; height: 40px;">
                            <i class="flaticon-book text-white fs-16"></i>
                          </div>
                        </div>
                        <div>
                          <h6 class="mb-0 fw-semibold">{{ historique.document?.titre || 'Titre non disponible' }}</h6>
                          <small class="text-muted">
                            Par {{ historique.document?.auteur.nom || 'Auteur inconnu' }} {{ historique.document?.auteur.prenoms || 'Auteur inconnu' }}
                          </small>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span class="badge bg-secondary">
                        {{ historique.document?.categorie?.nom || 'Non définie' }}
                      </span>
                    </td>
                    <td>
                      {{ formatDate(historique.createdAt) }}
                    </td>
                    <td>
                      {{ formatTime(historique.createdAt) }}
                    </td>
                    <td>
                      <div class="d-flex gap-2">
                        <button 
                          class="btn btn-sm btn-outline-primary"
                          @click="voirDocument(historique.document)"
                          title="Voir le document">
                          <i class="flaticon-eye"></i>
                        </button>
                        <button 
                          class="btn btn-sm btn-outline-success"
                          @click="telechargerDocument(historique.document)"
                          title="Télécharger">
                          <i class="flaticon-download"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
               <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
                <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
              </div>
              
              <!-- Message si aucun historique -->
              <div v-if="historiques.length === 0" class="text-center py-5">
                <i class="flaticon-book fs-1 text-muted"></i>
                <h5 class="text-muted mt-3">Aucun historique trouvé</h5>
                <p class="text-muted">Votre historique de lecture apparaîtra ici.</p>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue';
import ApiService from '@/services/ApiService';
import { error, success } from '@/utils/utils';
import { useRouter } from 'vue-router';
import PaginationComponent from '@/components/Utilities/Pagination.vue';

export default defineComponent({
  name: 'HistoriqueLecture',
  components: {
    PaginationComponent
  },
  setup() {
    const router = useRouter();

    // Reactive state
    const historiques = ref<Array<any>>([]);
    const loading = ref(false);
    const page = ref(1);
    const limit = ref(10);
    const totalElements = ref(0);
    const totalPages = ref(0);
    const baseUrl = ref(ApiService.vueInstance.axios.defaults.baseURL?.split("api")[0]);

     const handlePaginate = ({ page_, limit_ }) => {
          try {
            page.value = page_;
            limit.value = limit_;
            getHistoriqueLecture();
          } catch (error) {
            //
            
          }
        };
    // Filtres
    const selectedPeriod = ref('all');
    const startDate = ref('');
    const endDate = ref('');
    const searchTerm = ref('');

    // Statistiques computed
    const totalLectures = computed(() => historiques.value.length);
    const documentsUniques = computed(() => {
      const uniqueDocuments = new Set(historiques.value.map(h => h.document?.id));
      return uniqueDocuments.size;
    });
    const lecturesAujourdhui = computed(() => {
      const today = new Date().toDateString();
      return historiques.value.filter(h => 
        new Date(h.createdAt).toDateString() === today
      ).length;
    });
    const lecturesCetteSemaine = computed(() => {
      const weekAgo = new Date();
      weekAgo.setDate(weekAgo.getDate() - 7);
      return historiques.value.filter(h => 
        new Date(h.createdAt) >= weekAgo
      ).length;
    });


    // Methods
    const getHistoriqueLecture = async () => {
      loading.value = true;
      try {
        const params = new URLSearchParams({
          page: page.value.toString(),
          limit: limit.value.toString(),
          types: 'LECTURE'
        });

        if (searchTerm.value) {
          params.append('search', searchTerm.value);
        }
        if (startDate.value) {
          params.append('startDate', startDate.value);
        }
        if (endDate.value) {
          params.append('endDate', endDate.value);
        }

        const response = await ApiService.get(`/historiques/user/lecture?${params}`);
        historiques.value = response.data.data.data;
        totalElements.value = response.data.data.totalElements;
        totalPages.value = response.data.data.totalPages;
      } catch (err) {
        error('Erreur lors du chargement de l\'historique');
      } finally {
        loading.value = false;
      }
    };

    const applyFilters = () => {
      // Gérer la période prédéfinie
      if (selectedPeriod.value !== 'all') {
        const now = new Date();
        let start = new Date();
        
        switch (selectedPeriod.value) {
          case 'today':
            start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            break;
          case 'week':
            start = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
            break;
          case 'month':
            start = new Date(now.getFullYear(), now.getMonth(), 1);
            break;
          case 'year':
            start = new Date(now.getFullYear(), 0, 1);
            break;
        }
        startDate.value = start.toISOString().split('T')[0];
        endDate.value = now.toISOString().split('T')[0];
      }

      page.value = 1;
      getHistoriqueLecture();
    };

   

    const voirDocument = (document: any) => {
      if (document?.id) {
        router.push({
          name: 'pdf-viewer',
          params: { id: document.id },
          query: { 
            pdfUrl: `${baseUrl.value}uploads/${document.nomFichier}` 
          }
        });
      }
    };

    const telechargerDocument = (document: any) => {
      if (document?.nomFichier) {
        const downloadUrl = `${baseUrl.value}uploads/${document.nomFichier}`;
        window.open(downloadUrl, '_blank');
      }
    };

    const formatDate = (dateString: string) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('fr-FR');
    };

    const formatTime = (dateString: string) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    };

    // Lifecycle
    onMounted(() => {
      baseUrl.value = ApiService.vueInstance.axios.defaults.baseURL?.split("api")[0];
      getHistoriqueLecture();
    });

    return {
      historiques,
      loading,
      page,
      limit,
      totalElements,
      totalPages,
      handlePaginate,
      selectedPeriod,
      startDate,
      endDate,
      searchTerm,
      totalLectures,
      documentsUniques,
      lecturesAujourdhui,
      lecturesCetteSemaine,
      getHistoriqueLecture,
      applyFilters,
      voirDocument,
      telechargerDocument,
      formatDate,
      formatTime
    };
  }
});
</script>

<style scoped>
.table th {
  border-top: none;
  font-weight: 600;
  color: #495057;
}

.pagination .page-link {
  border: 1px solid #dee2e6;
  color: #495057;
}

.pagination .page-item.active .page-link {
  background-color: #007bff;
  border-color: #007bff;
}

.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
</style>
